import React from 'react';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { formatCampaignReward } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { CampaignConfigDto } from '@coretava/api/ecommerce-service';

const TakeSurvey: React.FC<{
  campaign: CampaignConfigDto,
}> = ({
  campaign,
}) => {
  const handleClick = React.useCallback(() => {
    if (!UserStore.user?.phone) {
      UiStore.openSignupPopup();
    } else {
      UiStore.setPage(Pages.survey);
    }
  }, [UserStore.user?.phone]);

  return (
    <Box>
      <Typography fontSize={14} color="#4F4F4F">
        <Trans
          i18nKey="campaigns.boosters.survey.widget.answer"
          defaults="Complete this quick survey and unlock a {{reward}} discount!"
          values={{
            reward: formatCampaignReward(campaign),
          }}
        />
      </Typography>
      <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleClick}>
        <Trans
          i18nKey="campaigns.boosters.survey.widget.take"
          defaults="Take survey"
        />
      </Button>
    </Box>

  );
};

export default observer(TakeSurvey);
